import API from './API'
import Record_behavir from './FirebaseAPI/RecordBill'
import Cookies from 'js-cookie'

var record = new Record_behavir()

const route = 'driver'

var img_vacant = require('../../images/driver-status/map/taxi.png')
var img_logout = require('../../images/driver-status/map/logout.png')
var img_suspension = require('../../images/driver-status/ban.png')
var img_rest = require('../../images/driver-status/map/rest.png')
var img_dispatched = require('../../images/driver-status/map/hailing.png')
var img_shift = require('../../images/driver-status/map/shift.png')
var img_disappearance = require('../../images/driver-status/map/interrupt.png')
var img_hired = require('../../images/driver-status/map/take_passenger.png')

var Driver = (function () {
  function driver() {}
  driver.prototype.getList = function (teamCode) {
    return API.get(`${route}/list/`, { params: { code: teamCode } })
  }
  driver.prototype.create = function (payload) {
    return API.post(route, payload)
      .then((data) => {
        let recordInfo = {}
        recordInfo.type = '單一司機資料'
        recordInfo.event = '新增司機'
        recordInfo.code = Cookies.get('GladTeamCode')
        recordInfo.id = data.id
        recordInfo.note = payload
        recordInfo.user_name = Cookies.get('GladName')
        recordInfo.user_id = ''
        record.postRecord(recordInfo)
        return {
          success: true,
          message: data,
        }
      })
      .catch((err) => {
        return {
          success: false,
          message: err.response.data.error.message,
        }
      })
  }
  driver.prototype.getDetail = async function (id) {
    return await API.get(`${route}/${id}`)
      .then((data) => {
        return {
          success: true,
          message: data,
        }
      })
      .catch((err) => {
        return {
          success: false,
          message: err,
        }
      })
  }
  driver.prototype.remove = async function (id) {
    return await API.delete(`${route}/${id}`)
      .then((data) => {
        let recordInfo = {}
        recordInfo.type = '單一司機資料'
        recordInfo.event = '封存司機'
        recordInfo.code = Cookies.get('GladTeamCode')
        recordInfo.id = Number(id)
        recordInfo.note = ''
        recordInfo.user_name = Cookies.get('GladName')
        recordInfo.user_id = ''
        record.postRecord(recordInfo)
        return {
          success: true,
          message: data,
        }
      })
      .catch((err) => {
        return {
          success: false,
          message: err,
        }
      })
  }
  driver.prototype.updateInfo = async function (id, payload, isChange = false) {
    /* console.log(JSON.stringify(payload)) */
    return await API.put(`${route}/${id}/info`, payload)
      .then((data) => {
        if (!data.success) throw data.result
        // 有異動才要記錄
        if (isChange) {
          let recordInfo = {}
          recordInfo.type = '單一司機資料'
          recordInfo.event = '更新司機資料'
          recordInfo.code = Cookies.get('GladTeamCode')
          recordInfo.id = Number(id)
          recordInfo.note = payload
          recordInfo.user_name = Cookies.get('GladName')
          recordInfo.user_id = ''
          record.postRecord(recordInfo)
        }
        return {
          success: true,
          message: data,
        }
      })
      .catch((err) => {
        return {
          success: false,
          message: err,
        }
      })
  }
  driver.prototype.updateSuspension = async function (id, payload) {
    return await API.put(`/driver-v2/${id}/suspension`, payload)
      .then((data) => {
        if (!data.success) throw new RangeError(data.result)
        let recordInfo = {}
        recordInfo.type = '單一司機資料'
        recordInfo.event = '調整司機權限'
        recordInfo.code = Cookies.get('GladTeamCode')
        recordInfo.id = Number(id)
        recordInfo.note = payload
        recordInfo.user_name = Cookies.get('GladName')
        recordInfo.user_id = ''
        record.postRecord(recordInfo)
        return {
          success: true,
          message: data,
        }
      })
      .catch((err) => {
        return {
          success: false,
          message: err,
        }
      })
  }
  driver.prototype.updatePayment = function (id, data) {
    return API.put(`${route}/${id}/payment`, data)
  }
  driver.prototype.getAllDriverLocation = function (status, onlyEmpty) {
    var params = {}
    if (typeof status !== 'undefined') {
      params.status = status
    }
    if (typeof onlyEmpty !== 'undefined') {
      params.onlyEmpty = onlyEmpty
    }

    return API.get(`${route}/all-location/`, { params: params })
  }

  driver.prototype.getInfo = function (account) {
    return API.get(`${route}/info`, { params: { account } })
  }
  driver.prototype.getTrajectory = function (id, params) {
    return API.get(`${route}/${id}/trajectory`, { params })
  }
  driver.prototype.formatService = function (service_list) {
    service_list = service_list.split(',')
    service_list = service_list.map((service) => {
      switch (service) {
        case '1':
          return '寵物友善'
          break
        case '2':
          return '可載輪椅'
          break
        case '3':
          return '小型搬家'
          break
        case '4':
          return '無檳榔'
          break
        case '5':
          return '無菸車'
          break
        case '6':
          return '日語'
          break
        case '7':
          return '英語'
          break
        case '8':
          return '無障礙車'
          break
        case '9':
          return '接電'
          break
        case '10':
          return '五年新車'
          break
        case '11':
          return '貨物接送'
          break
        case '12':
          return '代駕'
          break
        case '13':
          return '休旅車'
          break
        case '14':
          return '企業簽單'
          break
        default:
          return
      }
    })
    return service_list.join(',')
  }
  driver.prototype.getFormatStatus = function (status) {
    switch (status) {
      case 0:
        return {
          name: '休息中',
          img: img_rest,
        }
      case 1:
        return {
          name: '空車',
          img: img_vacant,
        }
      case 2:
        return {
          name: '派遣中',
          img: img_dispatched,
        }
      case 3:
        return {
          name: '載客中',
          img: img_hired,
        }
      case 4:
        return {
          name: '排班車',
          img: img_shift,
        }
      case 5:
        return {
          name: '登出',
          img: img_logout,
        }
      case 6:
        return {
          name: '失聯',
          img: img_disappearance,
        }
      case 7:
        return {
          name: '停權車',
          img: img_suspension,
        }
      default:
    }
  }
  driver.getDriverType = function (type) {
    switch (type) {
      case '0':
        return '一般計程車'
      case '1':
        return '多元計程車'
      default:
        return '一般計程車'
    }
  }
  driver.getAuthorize = function (authorize) {
    switch (Number(authorize)) {
      case 0:
        return '正常授權'
      case 1:
        return '停權'
      case 2:
        return '審核中'
      default:
        return '正常授權'
    }
  }
  return driver
})()
export default Driver



// WEBPACK FOOTER //
// ./src/assets/js/libs/Driver.js